// University of Illinois Chicago's undergraduate majors (#2652, round 2).
// Read on 2026-10-01 from the official 2026-2027 Undergraduate Catalog's
// Degree Program, Minor, and Certificate List (catalog.uic.edu), which lists
// each college's departments and their degree programs with the degree
// (BA, BS, BFA, BDes, BMus): every bachelor's line kept. The catalog's
// "BA with a Major" / "BS with a Major" is shown as BA / BS. Left out:
// minors, concentrations, joint BS/MS and BA/MPH programs, campus
// certificates, preprofessional studies and the Doctor of Pharmacy. Kept as
// listed: the two Bachelor of Business Administration Completion Programs
// (degree BBA) and the RN/BSN Completion Program (the catalog names no
// separate degree for it, so none is shown). Names are the catalog's, with
// one curly apostrophe made straight ("Gender and Women's Studies"). 98 lines.
const majors = {
    "slug": "university-of-illinois-chicago",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in UIC's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Minors, concentrations, joint BS/MS and BA/MPH programs, certificates, preprofessional studies and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Applied Health Sciences",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Health Information Management",
                    "degree": "BS"
                },
                {
                    "name": "Disability and Human Development",
                    "degree": "BS"
                },
                {
                    "name": "Health and Rehabilitation Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Architecture, Design, and the Arts",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "BA"
                },
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art Education",
                    "degree": "BFA"
                },
                {
                    "name": "Interdisciplinary Education in the Arts",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BDes"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BDes"
                },
                {
                    "name": "Design Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Business",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BMus"
                },
                {
                    "name": "Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "BMus"
                },
                {
                    "name": "Theatre and Performance",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Design Production and Technology",
                    "degree": "BA"
                },
                {
                    "name": "Acting",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Business Administration",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Bachelor of Business Administration Completion Program (on-campus)",
                    "degree": "BBA"
                },
                {
                    "name": "Bachelor of Business Administration Completion Program (online)",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Information and Decision Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                }
            ],
            "note": "The two Bachelor of Business Administration Completion Programs are for students who transfer in with college work; first-year business applicants choose one of the BS majors."
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Urban Education",
                    "degree": "BA"
                },
                {
                    "name": "Human Development and Learning",
                    "degree": "BA"
                },
                {
                    "name": "Inclusive and Special Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Design",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Black Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Criminology Law and Justice",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science and Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Teaching of English",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "Teaching of French",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Germanic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Teaching of German",
                    "degree": "BA"
                },
                {
                    "name": "Global Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Teaching of Spanish",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Teaching of History",
                    "degree": "BA"
                },
                {
                    "name": "Integrated Health Studies",
                    "degree": "BS"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Latino Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science and Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Teaching of Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science and Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Central and Eastern European Studies",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Applied Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "RN/BSN Completion Program",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Urban Planning and Public Affairs",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Retzky College of Pharmacy",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "UIC 2026-2027 Undergraduate Catalog, Degree Program, Minor, and Certificate List",
                "url": "https://catalog.uic.edu/ucat/degree-programs/degree-minors/"
            },
            "majors": [
                {
                    "name": "Public Health Practice",
                    "degree": "BA"
                },
                {
                    "name": "Public Health Sciences",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
